import botones_logo from "../../../assets/botones-links-pago.webp";
export const Hero = () => {
  return (
    <div className='relative p-0'>
    <div className="overflow-hidden lg:h-[50vh]">
        <img className="translate-y-4 3xs:translate-y-16 2xs:translate-y-2 xs:translate-y-10 sm:translate-y-4 lg:translate-y-10 xl:-translate-y-10 2xl:-translate-y-40 3xl:-translate-y-80 w-full h-auto object-contain" id="botones" src= {botones_logo} alt="botones" />
    </div>
</div>
  )
}
